import { normalQueryTypes } from '@ow/utils'

export const filterSpec = {
  queryTypes: ['containString', 'notContainString', 'isNull', 'notNull'].map(
    (p) => normalQueryTypes[p]
  ),
}
